@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.orders-drawer-tags {
  display: flex;
  align-items: center;
  padding: 5px 15px;
}

.add-tag-row {
  &.no-tag-row {
    display: flex;
    width: 100%;
    align-items: center;
  }
}

.tags {
  width: 100%;
}

.tag-dropdown {
  align-self: center;
}

.no-tag-message {
  font-style: italic;
  width: 100%;
  color: @orders-drawer--default--text-color;
  text-align: center;
  font-size: 14px;
  padding: 10px 0;
}

.pill {
  margin: 5px;
}

.pill-wrapper {
  display: flex;
  align-items: center;
  height: 100%;

  .pill {
    margin: 0 0 0 5px;
  }
}
